

export const ACTIVITY_TYPES_FORMAT = {
    "global": "Global",
    "strikes": "Strikes",
    "crucible": "Crucible",
    "gambit": "Gambit",
    "seasonal": "Seasonal",
    "playlist": "Playlist",
    "event": "Event",
    "raid": "Raid",
    "iron_banner": "Iron Banner",
    "trials": "Trials",
    "edz": "EDZ",
    "moon": "Moon",
    "tangled_shore": "Tangled Shore",
    "dreaming_city": "Dreaming City",
    "nessus": "Nessus",
    "europa": "Europa",
    "cosmodrome": "Cosmodrome",
};

export const PROGRESS_DESC_SYMBOLS = {
    "Bow": "",
    "Auto Rifle": "",
    "Pulse Rifle": "",
    "Scout Rifle": "",
    "Hand Cannon": "",
    "Shotgun": "",
    "Sniper Rifle": "",
    "Fusion Rifle": "",
    "Submachine Gun": "",
    "SMG": "",
    "Rocket Launcher": "",
    "Sidearm": "",
    "Grenade Launcher": "",
    "Grenade Launcher (Special)": "",
    "Power Grenade Launcher": "",
    "Trace Rifle": "",
    "Linear Fusion Rifle": "",
    "Sword": "",
    "Machine Gun": "",
    "Kinetic Grenade Launcher": "",
    "Kinetic": "",
    "Precision": "",
    "Headshot": "",
    "Solar": "",
    "Arc": "",
    "Void": "",
    "Stasis": "",
    "Grenade": "",
    "Melee": "",
};

export const OBJECTIVE_TYPES_FORMAT = {
    null: "General",
    "kinetic": "Kinetic Weapons",
    "energy": "Energy Weapons",
    "power": "Power Weapons",
    "primary": "Primary Ammo",
    "special": "Special Ammo",
    "hand_cannon": "Hand Cannon",
    "submachine_gun": "Submachine Gun",
    "auto_rifle": "Auto Rifle",
    "fusion_rifle": "Fusion Rifle",
    "linear_fusion_rifle": "Linear Fusion Rifle",
    "sniper_rifle": "Sniper Rifle",
    "pulse_rifle": "Pulse Rifle",
    "scout_rifle": "Scout Rifle",
    "sidearm": "Sidearm",
    "shotgun": "Shotgun",
    "trace_rifle": "Trace Rifle",
    "bow": "Bow",
    "normal_grenade_launcher": "Grenade Launcher",
    "special_grenade_launcher": "Grenade Launcher (Special)",
    "power_grenade_launcher": "Grenade Launcher (Power)",
    "machine_gun": "Machine Gun",
    "sword": "Sword",
    "rocket_launcher": "Rocket Launcher",
    "solar": "Solar",
    "arc": "Arc",
    "void": "Void",
    "precision": "Precision",
    "melee": "Melee",
    "grenade": "Grenade",
    "super": "Super",
    "finisher": "Finisher",
    "abilities": "Abilities",
    "orbs": "Orbs",
    "cabal": "Cabal",
    "vex": "Vex",
    "fallen": "Fallen",
    "taken": "Taken",
    "scorn": "Scorn",
    "hive": "Hive",
};
